
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import EventFooter from '@/components/block/EventFooter.vue'
import EventCardArchive from '@/components/block/EventCardArchive.vue'
import Alert from '@/components/elements/Alert.vue'
import InputSelectbox from '@/components/elements/InputSelectbox.vue'
import Loader from '@/components/elements/Loader.vue'
import Button from '@/components/elements/Button.vue'
import { useEvent } from '@/provider/event'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Pagination from '@/components/block/Pagination.vue'
export default {
  name: 'EventsArchive',
  components: {
    HeadingLv1,
    EventFooter,
    InputSelectbox,
    Alert,
    EventCardArchive,
    Loader,
    Button,
    Pagination
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const {
      totalArchivePages: totalPages,
      loadArchives,
      archives: archivesBase,
      loadAllArchiveCategorys,

      loading,
      allArchiveCategories,
      allArchiveFilterTypes,
      allArchiveTopics
    } = useEvent()

    loadAllArchiveCategorys()

    const loadEventArchies = () => {
      loadArchives({
        per_page: 20,
        page: route.query.page ? Number(route.query.page) : undefined,
        category: route.query.category ? route.query.category : undefined,
        tag: route.query.tag ? route.query.tag : undefined,
        type: route.query.type ? route.query.type : undefined
      })
    }

    const topics = computed(() => allArchiveTopics.value)
    const categories = computed(() => allArchiveCategories.value)
    const filterTypes = computed(() => allArchiveFilterTypes.value)
    const selectedTopic = ref<any>(
      route.query.tag ? route.query.tag : undefined
    )
    const selectedCategory = ref<any>(
      route.query.category ? route.query.category : undefined
    )
    const selectedFilterType = ref<any>(
      route.query.type ? route.query.type : undefined
    )
    const selectTopic = (val: string) => {
      selectedTopic.value = val
      router.push({
        name: 'EventsArchivesList',
        query: { ...route.query, tag: val ? decodeURI(val) : '', page: 1 }
      })
    }
    const selectCategory = (val: string | null | undefined) => {
      selectedCategory.value = val
      router.push({
        name: 'EventsArchivesList',
        query: { ...route.query, category: val ? decodeURI(val) : '', page: 1 }
      })
    }
    const selectFilterType = (val: string | null | undefined) => {
      selectedFilterType.value = val
      router.push({
        name: 'EventsArchivesList',
        query: { ...route.query, type: val ? decodeURI(val) : '', page: 1 }
      })
    }

    const archives = computed(() => archivesBase.value)

    watch(
      () => [
        route.query.page,
        route.query.type,
        route.query.category,
        route.query.tag
      ],
      (next, prev) => {
        if (JSON.stringify(next) === JSON.stringify(prev)) return
        loadEventArchies()
      },
      { immediate: true }
    )

    return {
      loading,
      topics,
      categories,
      filterTypes,
      selectTopic,
      selectedTopic,
      selectCategory,
      selectedCategory,
      selectFilterType,
      selectedFilterType,
      archives,
      totalPages
    }
  }
}
